import { render, staticRenderFns } from "./BlockProduct.vue?vue&type=template&id=3fa29eaa&scoped=true&"
import script from "./BlockProduct.vue?vue&type=script&lang=js&"
export * from "./BlockProduct.vue?vue&type=script&lang=js&"
import style0 from "./BlockProduct.vue?vue&type=style&index=0&id=3fa29eaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa29eaa",
  null
  
)

export default component.exports